import { Guardian, GuardianRelation } from '@dreryk/egabinet-patient-frontend-api';
import { MedicalLeaveGuardianRelation } from '@dreryk/egabinet-ezla-frontend-api';

import { GuardianMedicalLeaveFormGuardian } from '../../guardianMedicalLeave.types';

const mapGuardianRelationToMedicalLeave = (relation: GuardianRelation): MedicalLeaveGuardianRelation => {
   switch (relation) {
      case 'MOTHER':
         return 'CHILD';
      case 'FATHER':
         return 'CHILD';
      case 'NEXT_OF_KIN':
         return 'NEXT_OF_KIN';
      case 'ACTUAL_GUARDIAN':
      default:
         return 'OTHER';
   }
};
export const mapGuardianPersonalDataToFormGuardian = (
   guardianPersonalData: Guardian
): GuardianMedicalLeaveFormGuardian => ({
   firstName: guardianPersonalData.firstName.asString(),
   middleName: guardianPersonalData.middleName?.asString() ?? null,
   lastName: guardianPersonalData.lastName.asString(),
   guardianExternalIdentifier: guardianPersonalData.externalIdentifier,
   relationCode: mapGuardianRelationToMedicalLeave(guardianPersonalData.relation),
   birthDate: null,
   address: {
      city: guardianPersonalData.address.findTown()?.getName() ?? null,
      flat: guardianPersonalData.address.findFlat()?.asString() ?? null,
      street: guardianPersonalData.address.findStreet()?.asString() ?? null,
      house: guardianPersonalData.address.findBuilding()?.asString() ?? null,
      postcode: guardianPersonalData.address.findPostcode() ?? null,
      country: guardianPersonalData.address.getCountry(),
   },
});
